import {styled} from "@mui/material/styles";

export const Header = styled("h2")`
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    margin: 1rem 0;
`

export const Title = styled("h2")`
    color: #132128;
    font-size: 1.2rem;
    font-weight: 700;
`

export const SubTitle = styled("h3")`
    color: #424D53;
    font-size: 1rem;
    font-weight: 600;
`

export const Paragraph = styled("p")`
    color: #424D53;
    font-size: 1rem;
    font-weight: 400;
    margin-top: 10px;
    line-height: 22px;
    font-family: 'Roboto',sans-serif;
`

export const PreParagraph = styled("pre")`
    color: #424D53;
    font-size: 1rem;
    font-weight: 400;
    margin-top: 10px;
    line-height: 22px;
    font-family: 'Roboto',sans-serif;
    white-space: break-spaces;
`
